// src/js/reducers/index.js
import * as types from "../constants/action-types";

export default function userLocationReducer(state = {}, action) {
    switch (action.type) {
        case types.LOGOUT:
            return []
        case types.CREATE_USERLOCATION_SUCCESS:

            var result = action.userLocation || {};
            
            return result;

        case types.UPDATE_USERLOCATION_SUCCESS:
            
            var result = action.userLocation || {};
            
            return result;

        case types.LOAD_USERLOCATION_SUCCESS:

            return action.userLocation || {};

        case types.DELETE_USERLOCATION_SUCCESS:

            return {};

        default:
            return state;
    };
};


